import { type CertificationBadgeProps } from './components/CertificationBadge';

export const certifications: CertificationBadgeProps[] = [
  {
    label: 'CompTIA A+',
    issuer: 'CompTIA',
  },
  {
    label: 'CCNA',
    issuer: 'Cisco',
  },
  {
    label: 'AWS Solutions Architect – Associate',
    issuer: 'Amazon Web Services',
  },
  {
    label: 'AWS Certified Developer – Associate',
    issuer: 'Amazon Web Services',
  },
  {
    label: 'AWS Certified Security - Specialty',
    issuer: 'Amazon Web Services',
  },
  {
    label: 'AWS Certified AI Practitioner',
    issuer: 'Amazon Web Services',
  },
  {
    label: 'AWS Certified Machine Learning Engineer - Associate',
    issuer: 'Amazon Web Services',
  },
];
